export default __webpack_public_path__ + "static/media/146.70702b0c.svg";